import { IBuscaCredoresRequest } from './types';
import api from "../api";
import { IUser } from 'interfaces/User';

export const buscaCredoresService = async (data: IBuscaCredoresRequest) => await api.get<IUser>('busca-credores', data);
export const buscaCredoresServiceWithName = async (data: IBuscaCredoresRequest, nome: string) => await api.get<IUser>('busca-credores/'+nome, data);

export const buscaHonorariosService = async (data: IBuscaCredoresRequest) => await api.get<IUser>('busca-honorario-sucumbencial', data);